import { Snippet } from '../../dataModels';

export const tagSnippet: Snippet = {
  shiftsummaryDisplyId: '14601885-bbf3-ec11-9147-005056b29cce',
  name: 'A_TEST_TAG',
  displayName: 'A_TEST_TAG',
  description: null,
  order: 6,
  type: 'Tag',
  enableEdit: 'False',
  enableComment: true,
  isEdited: false,
  maxRows: 20,
  canAddDeleteRows: false,
  configuration: {
    rowTitleKey: 'TagName',
    columnCount: 5,
    columns: [
      {
        id: 1,
        name: 'TagName',
        displayName: 'Tag Name',
        controlType: 'Text - Single Line',
        controlValues: null,
        visible: 'True',
      },
      {
        id: 2,
        name: 'TagLabel',
        displayName: 'Tag Label',
        controlType: 'Text - Single Line',
        controlValues: null,
        visible: 'True',
      },
      {
        id: 3,
        name: 'Value',
        displayName: 'Value',
        controlType: 'Text - Single Line',
        controlValues: null,
        visible: 'True',
      },
      {
        id: 4,
        name: 'Date',
        displayName: 'Date',
        controlType: 'Text - Single Line',
        controlValues: null,
        visible: 'True',
      },
      {
        id: 5,
        name: 'Comments',
        displayName: 'Comments',
        controlType: 'Text',
        controlValues: null,
        visible: 'True',
      },
    ],
    matrixCells: null,
  },
  data: [
    {
      rollupDetails: null,
      rowCount: 2,
      rowData: [
        {
          TagName: 'SNGZPH35::C_CONSTORE_CHECK',
          TagLabel: 'C_CONSTORE_CHECK',
          Value: null,
          Date: null,
          Comments: null,
        },
        {
          TagName: 'SNGZPH35::USM_CONSTORE_AVGRATE',
          TagLabel: 'USM_CONSTORE_AVGRATE',
          Value: null,
          Date: null,
          Comments: null,
        },
      ],
    },
  ],
  count: 0,
  groupSnippets: null,
};
